import userUtils from 'utils/User';
import skuHelpers from 'utils/skuHelpers';

const isRougeExclusiveEnabled = Boolean(Sephora.configurationSettings.isRougeExclusiveEnabled);
const isRougeCashFlagEnabled = Boolean(Sephora.configurationSettings.isRougeCashFlagEnabled);

const isRougeExclusive = () => {
    return isRougeExclusiveEnabled && userUtils.isRouge();
};

const updateRougeExclusiveSkus = (skus, basket) => {
    if (!isRougeExclusive() || !skus || !basket) {
        return skus;
    }

    const { netBeautyBankPointsAvailable } = basket;

    const newSkus = skus.map(s => {
        const isInBasket = skuHelpers.isInBasket(s.skuId);

        if (!isInBasket) {
            s.hasNotEnoughPointsToRedeem = s.rewardPoints > netBeautyBankPointsAvailable;
        }

        return s;
    });

    return newSkus;
};

const updateRougeExclusiveBiRewardGroups = (biRewardGroups, basket) => {
    if (!isRougeExclusive() || !biRewardGroups || !basket) {
        return biRewardGroups;
    }

    Object.entries(biRewardGroups).forEach(([key, value]) => {
        biRewardGroups[key] = updateRougeExclusiveSkus(value, basket);
    });

    return biRewardGroups;
};

export default {
    isRougeExclusiveEnabled,
    isRougeCashFlagEnabled,
    isRougeExclusive,
    updateRougeExclusiveSkus,
    updateRougeExclusiveBiRewardGroups
};
